import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { useState } from 'react';

const EmbeddedYouTubeVideoModal = loadable(() => import('@Components/Shared/Modals/EmbeddedYouTubeVideoModal'), true);

const EmbeddedYouTubeVideoThumbnail = (props) => {
    const [embeddedYouTubeVideoModalStatus, setEmbeddedYouTubeVideoModalStatus] = useState({ show: false });

    const closeVideoModal = () => {
        setEmbeddedYouTubeVideoModalStatus({ show: false });
    };

    const openVideoModal = () => {
        props.onOpen?.();
        setEmbeddedYouTubeVideoModalStatus({ show: true });
    };

    return (
        <div className="youtube-thumbnail" aria-describedby={props.videoId + "-text"}>
            {(embeddedYouTubeVideoModalStatus.show) &&
                <EmbeddedYouTubeVideoModal
                    onClose={closeVideoModal}
                    videoId={props.videoId}
                />}
            <div className="youtube-thumbnail-btn">
                <div className="youtube-thumbnail-img" role="button" tabIndex="0" onClick={openVideoModal} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openVideoModal(); } }}>
                    <img src={"https://img.youtube.com/vi/" + props.videoId + "/hqdefault.jpg"} alt={props.altText} />
                </div>
                {props.descriptionText &&
                    <div id={props.videoId + "-text"} className="youtube-thumbnail-text" role="button" tabIndex="0" onClick={openVideoModal} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openVideoModal(); } }}>
                        {props.descriptionText}
                    </div>
                }
            </div>
        </div>
    );
};

export default EmbeddedYouTubeVideoThumbnail;